import { render, staticRenderFns } from "./validations-bulk-actions.vue?vue&type=template&id=cf3b27c2"
import script from "./validations-bulk-actions.vue?vue&type=script&lang=js"
export * from "./validations-bulk-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports